import React, { useState } from 'react';

/**
 * Barra de aviso informativo para telas com dados que não substituem orientação profissional.
 * 
 * Props:
 *  - tipo: 'previsao' | 'irrigacao' | 'zarc' | 'sensor' (define o texto exibido)
 *  - collapsed: (bool) inicia recolhido? padrão true
 */
export default function DisclaimerInfo({ tipo = 'previsao', collapsed: initialCollapsed = true }) {
  const [aberto, setAberto] = useState(!initialCollapsed);

  const textos = {
    previsao: {
      icone: '🌦️',
      resumo: 'Dados informativos — não substituem assessoria agrometeorológica',
      detalhe: 'As previsões climáticas são geradas por modelos numéricos e podem apresentar variações. Não use essas informações como único critério para decisões de plantio, colheita ou manejo. Consulte um profissional habilitado.',
    },
    irrigacao: {
      icone: '💧',
      resumo: 'Estimativas orientativas — calibre conforme sua realidade local',
      detalhe: 'Os cálculos de irrigação e balanço hídrico são estimativas baseadas em dados climáticos e parâmetros padrão. Condições locais de solo, topografia e variedade podem diferir significativamente. Recomenda-se validação com engenheiro agrônomo ou técnico agrícola.',
    },
    zarc: {
      icone: '🌱',
      resumo: 'Dados ZARC — fonte: MAPA. Consulte a portaria vigente antes de decidir',
      detalhe: 'O Zoneamento Agrícola de Risco Climático (ZARC) é fornecido pelo Ministério da Agricultura, Pecuária e Abastecimento. As tabelas podem ser atualizadas pelo MAPA a qualquer momento. O ClimoraX não garante atualização em tempo real. Consulte sempre a portaria vigente em mapa.agricultura.gov.br.',
    },
    sensor: {
      icone: '📡',
      resumo: 'Dados de sensor — precisão depende da calibração do equipamento',
      detalhe: 'As leituras exibidas dependem da calibração, manutenção e posicionamento do sensor. O ClimoraX não garante a exatidão de dados provenientes de equipamentos de terceiros. Verifique periodicamente a calibração do seu dispositivo.',
    },
  };

  const info = textos[tipo] || textos.previsao;

  return (
    <div style={{
      background: '#fffbeb',
      border: '1px solid #f59e0b',
      borderRadius: 10,
      padding: aberto ? '10px 14px 12px' : '8px 14px',
      marginBottom: 12,
      fontSize: 12.5,
      color: '#92400e',
      transition: 'all 0.2s',
    }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          cursor: 'pointer',
          userSelect: 'none',
        }}
        onClick={() => setAberto(!aberto)}
      >
        <span style={{ fontSize: 16 }}>{info.icone}</span>
        <span style={{ flex: 1, fontWeight: 600, lineHeight: 1.4 }}>{info.resumo}</span>
        <span style={{ fontSize: 16, color: '#b45309', transform: aberto ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}>▾</span>
      </div>
      {aberto && (
        <div style={{ marginTop: 8, lineHeight: 1.6, color: '#78350f' }}>
          {info.detalhe}
        </div>
      )}
    </div>
  );
}
